/* eslint-disable */
import { clientForOwner as client } from '@/http/client';

class OwnerPortalApi {
  async get() {
    return client.get('/users/me/');
  }

  async getProperties() {
    return client.get('/realty/my_properties/');
  }

  async getPropertyById(id) {
    return client.get(`/realty/my_properties/${id}/`);
  }

  async getBookings({ status, limit, offset }) {
    return client.get('/realty/my_properties_bookings/', {
      params: {
        status,
        limit,
        offset,
      },
    });
  }

  async getUsageDocuments(usageId) {
    return client.get(`/realty/my_contracts/${usageId}`);
  }

  async getAnnouncments() {
    return client.get('/my_announcements/');
  }

  async getAnnouncments({ orderBy, search, limit, offset, config } = {}) {
    return client.get(`/announcements/my_announcements/`, {
      ...config,
      params: {
        orderBy,
        search,
        limit,
        offset,
      },
    });
  }

  async getAnnouncmentById(id) {
    return client.get(`/announcements/my_announcements/${id}/`);
  }

  async getCalendar(rentalPeriodAfter, rentalPeriodBefore) {
    return client.get('/realty/calendar/', {
      params: {
        rentalPeriodAfter,
        rentalPeriodBefore,
      },
    });
  }

  async getFinanceReport(unitId) {
    return client.get(`realty_finance/finance-report/${unitId}/`);
  }
}

export default new OwnerPortalApi();
